export default "__VITE_ASSET__BI61wRVz__"